module.exports = __webpack_public_path__ + "img/35.1.644a2bfb.jpg";